<template>
  <div class="breakdown">
    <div v-if="isLoading" class="loading">
      <spinner width="100" height="100" />
    </div>

    <div v-else class="grid">
      <BreakdownCardGraph
        v-for="(item, index) in categories"
        :key="index"
        :is-loading="breakdownLoading"
        :breakdown="breakdown"
        :category="item"
      />
    </div>
  </div>
</template>

<script>
import BreakdownCardGraph from './BreakdownCardGraph.vue'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapState } from 'vuex'

export default {
    components: {
        Spinner,
        BreakdownCardGraph,
    },
    data() {
        return {
            categories: ['age', 'gender', 'income', 'education'],
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.retrieveBreakdown()
    },
    computed: {
        ...mapState('dashboardAccount', {
            breakdown: state => state.breakdown,
            breakdownLoading: state => state.breakdownLoading
        }),
    },
    methods: {
        ...mapActions('dashboardAccount', ['retrieveBreakdown']),
    }
}
</script>

<style scoped>
.breakdown {
  flex: 1;
  width: 100%;
  height: 100%;
  max-height: 8000px;
  gap: 24px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 16px 0;
}

.loading {
  min-height: 520px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

/* responsive */
@media (max-width: 1300px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }
}
</style>
